export enum PostStatus {
    Draft = "DRAFT",
    Published = "PUBLISHED",
}